// Single formatting contract for the Season Dashboard.
//
// Every stat the dashboard renders goes through fmtStat. The one hard rule:
// null / undefined / NaN ALWAYS renders as an em-dash — never "0", never
// "NaN". This is the backward-compat guarantee for imports made before the
// 2026-07 parser extension (story stats simply don't exist on those games).

export const EM_DASH = '—';

export type StatKind =
  | 'avg3'    // batting-average style: .348 (leading zero stripped)
  | 'pct'     // 0–1 fraction → whole percent: 48%
  | 'pct1'    // 0–1 fraction → one decimal: 48.3%
  | 'count'   // integer count
  | 'ip'      // TRUE innings (4.667) → baseball notation: 4.2
  | 'ratio1'  // one-decimal ratio: 2.1
  | 'num2';   // two-decimal number: 4.50 (ERA/WHIP style)

export function fmtStat(value: any, kind: StatKind): string {
  const n = typeof value === 'number' ? value : parseFloat(value);
  if (value == null || isNaN(n)) return EM_DASH;

  switch (kind) {
    case 'avg3': {
      const s = n.toFixed(3);
      return n < 1 ? s.replace(/^(-?)0\./, '$1.') : s;
    }
    case 'pct':
      return `${Math.round(n * 100)}%`;
    case 'pct1':
      return `${(n * 100).toFixed(1)}%`;
    case 'count':
      return `${Math.round(n)}`;
    case 'ip': {
      // Input is TRUE innings (e.g. 4.667). Emit baseball thirds notation.
      let whole = Math.floor(n);
      let outs = Math.round((n - whole) * 3);
      if (outs === 3) { whole += 1; outs = 0; }
      return outs === 0 ? `${whole}` : `${whole}.${outs}`;
    }
    case 'ratio1':
      return n.toFixed(1);
    case 'num2':
      return n.toFixed(2);
  }
}
